const Suscribite = () => {
    return (
        <iframe 
            src="https://el-litoral.campaign-list.com/subscribe/la-semana-en-noticias/393f5d51-4edf-48eb-bc0d-247de107b061?embed"
            width="100%"
            height="310"
            loading="lazy"
            style={{
                border: "1px solid #cccccc",
            }}
        />
    )
}

export default Suscribite;
